module.exports = __webpack_public_path__ + "static/media/dev.23db06bf.png";